import { RootContainer } from "../../../root_container";
import { TonerAction } from "../../../actions/toner/toner_action";
import { TonerJsEnv } from "../../../models/toner/toner_js_env";
import { TonerBody } from "./toner_body";

export class TonerContainer extends RootContainer<TonerJsEnv> {
  constructor(model: TonerJsEnv) {
    super();
    this.mount(TonerBody, 'js-special-search-toner-body');

    // 初回描画
    this.update(model);

    // pageを更新するイベント
    TonerAction.UPDATE_EVENT.on((model: TonerJsEnv) => {
      this.update(model);
    });
  }
}